
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/privacy-policy",
      function () {
        return require("private-next-pages/help/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/privacy-policy"])
      });
    }
  